
export default {
    state: {
        logo: "",
        seasoncard: "",
        indexHeader: "",
        footerText1: "",
        footerText2: "",
        lun1: "",
        lun2: "",
        lun3: "",
    },
    getters: {
    },
    mutations: {
        updateOptions(state, option) {
            state.logo = option.logo;
            state.seasoncard = option.seasoncard;
            state.indexHeader = option.indexHeader;
            state.footerText1 = option.footerText1;
            state.footerText2 = option.footerText2;
            state.lun1 = option.lun1;
            state.lun2 = option.lun2;
            state.lun3 = option.lun3;
        }
    },
    actions: {
    },
    modules: {
    }
}
